import { HttpContextToken } from '@angular/common/http';

/**
 * @description
 * Token de `HttpContext` para peticiones que deben fallar de forma SILENCIOSA.
 *
 * Cuando está en `true`, el `authInterceptor` NO dispara el manejo de error global ante respuestas
 * `success:false` (200) ni errores HTTP: se salta tanto el `Swal` bloqueante de `ApiService.setError`
 * como la captura de `GlobalErrorHandlerService.handleError`. El error se SIGUE propagando al llamador
 * (vía `throw`/`throwError`) para que lo maneje él mismo — el patrón esperado es `console.warn` + no-op.
 *
 * Los demás comportamientos del interceptor permanecen intactos: headers de auth, y el manejo de 401
 * (`handleAuthFailure` / refresh de sesión) siguen ejecutándose igual.
 *
 * @example
 * this._http.get(url, { context: new HttpContext().set(SILENT_ERRORS, true) });
 */
export const SILENT_ERRORS = new HttpContextToken<boolean>(() => false);
